import { render, staticRenderFns } from "./VueUploadMultipleImage.vue?vue&type=template&id=10618550&scoped=true"
import script from "./VueUploadMultipleImage.vue?vue&type=script&lang=js"
export * from "./VueUploadMultipleImage.vue?vue&type=script&lang=js"
import style0 from "./VueUploadMultipleImage.vue?vue&type=style&index=0&id=10618550&prod&lang=css&scoped=true"
import style1 from "./VueUploadMultipleImage.vue?vue&type=style&index=1&id=10618550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10618550",
  null
  
)

export default component.exports